import { FloatingActions } from "./FloatingActions";
export default FloatingActions;